/**
 * Created by nghinv on Tue Jul 27 2021
 * Copyright (c) 2021 nghinv@lumi.biz
 */

import ColorPicker, { ColorPickerProps } from './ColorPicker';
import ColorAnimated from './components/ColorAnimated';

export default ColorPicker;

export {
  ColorAnimated,
  ColorPickerProps,
};
